import { useEffect } from 'react';
import useIntersectionObserver from './useIntersectionObserver';

const DEFAULT_OPTIONS = {
  loadMore: () => {},
  disabled: false
};

export default function useInfiniteScroll({
  loadMore,
  disabled,
  isLoading = false
} = DEFAULT_OPTIONS) {
  const { isIntersecting, targetRef, rootRef } = useIntersectionObserver({
    threshold: 1
  });
  useEffect(() => {
    let timerId = null;
    const shouldCall = !isLoading && !disabled && isIntersecting;
    if (shouldCall) {
      // for a brief momenet of time before rendering the new elements from returned from api
      // intersectionObserver is getting called twice or more because of the scroll position
      // so, it's quick hack which debounces the loadMore function
      // which will not call the loadMore twice or more before rendering the new elements
      timerId = setTimeout(() => {
        loadMore();
      }, 100);
    }
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [isIntersecting, disabled, isLoading, loadMore]);

  return {
    targetRef,
    rootRef
  };
}
